export const HELP_ARTICLE_CONSTANTS_IDS={
    auth: 1,
    change_user_data: 2,
    register_personal_account: 3,
    login_social_networks: 4,
    change_personal_cabinet: 5,
    connect_to_chant_bot: 6,
}